<template>
    <div class="relative flex cursor-pointer rounded-[8px]">
        <div
            class="relative rounded-[8px] lg:transition-all lg:duration-500 lg:hover:-translate-y-[1.5%] lg:hover:scale-[1.01]"
        >
            <img
                :src="item.image"
                :alt="item.key"
                loading="lazy"
                class="loader-image"
            />
            <div
                v-if="item?.label === 'hot'"
                class="absolute left-[4px] top-10 flex items-center rounded-r-full bg-[#FF573F] p-2 pr-4"
            >
                <img
                    :src="`${staticUrl}/assets/icons/fire.gif`"
                    loading="lazy"
                    class="w-[28px]"
                />
                <span class="bg-[#FF573F] font-semibold text-white">Hot</span>
            </div>
            <div
                v-if="item?.label === 'new'"
                class="absolute left-[4px] top-10 flex items-center rounded-r-full bg-[#09CA89] p-2 pr-4"
            >
                <img
                    :src="`${staticUrl}/assets/icons/star.gif`"
                    class="w-[28px]"
                />
                <span class="bg-[#09CA89] font-semibold text-white">New</span>
            </div>
        </div>
    </div>
</template>
<script setup>
// eslint-disable-next-line vue/require-prop-types
const { item } = defineProps(['item'])
const staticUrl = useRuntimeConfig().public.staticUrl
</script>
